import React from 'react';
import '../style/Procedure.css';

const steps = [
  {
    id: 1,
    title: 'Получение заявки',
    body: `Клиент подает заявку (оферту) на покупку, продажу или обмен виртуальных активов через данную платформу.\n\nТипы сделок:\n· Покупка виртуальных активов за национальную/иностранную валюту или электронные деньги.\n· Продажа виртуальных активов за национальную/иностранную валюту или электронные деньги.\n· Обмен одного вида виртуальных активов на другой.`
  },
  {
    id: 2,
    title: 'Получение активов',
    body: `Оператор принимает от клиента:\n· Деньги на текущий (расчётный) банковский счет.\n· Электронные деньги на электронный кошелек.\n· Виртуальные активы на адрес (идентификатор) виртуального кошелька.`
  },
  {
    id: 3,
    title: 'Встречное предоставление',
    body: `Оператор передает клиенту в зависимости от сделки:\n· Деньги.\n· Электронные деньги.\n· Виртуальные активы.`
  },
  {
    id: 4,
    title: 'Исполнение сделки',
    body: `Оператор действует от собственного имени и в своих интересах, используя данную платформу (информационные системы или программно-технические комплексы) в режиме самообслуживания.`
  }
];

export default function Procedure() {
  return (
    <section className="procedure-section" aria-labelledby="procedure-heading">
      <div className="procedure-header">
        <h2 id="procedure-heading" className="procedure-title">Процедура обмена виртуальных активов</h2>
      </div>

      <div className="timeline" role="list">
        {steps.map((s, idx) => (
          <article key={s.id} role="listitem" className={`timeline-item ${idx % 2 === 0 ? 'left' : 'right'}`}>
            <div className="timeline-marker" aria-hidden="true">
              <span className="marker-number">{s.id}</span>
            </div>

            <div className="timeline-card">
              <div className="card-icon" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                  <circle cx="12" cy="12" r="10" fill="#ffffff" opacity="0.06" />
                  <path d="M12 7v5l3 3" stroke="#0f766e" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>

              <div className="timeline-content">
                <h3>{s.title}</h3>
                <p className="timeline-text">{s.body.split('\n').map((line, i) => (
                  <span key={i}>{line}<br/></span>
                ))}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
